/**
 * The last errors this tab saw, sent with a bug report (components/BugButton.tsx):
 * every API call that failed (api/client.ts), including a fetch() that threw
 * before it sent anything, as the upload of a "02⧸01⧸2026" file did on
 * 2026-10-15; a part upload that failed; an uncaught error; a rejected promise
 * nothing handled. In memory only, so a reload starts empty.
 */
export interface SeenError { at: string; where: string; message: string }

const MAX = 10;
const seen: SeenError[] = [];

export function noteError(where: string, message: string): void {
  seen.push({ at: new Date().toISOString(), where: where.slice(0, 200), message: message.slice(0, 500) });
  if (seen.length > MAX) seen.splice(0, seen.length - MAX);
}

export const recentErrors = (): SeenError[] => seen.slice();

let watching = false;

/** Note uncaught errors and unhandled rejections from now on. */
export function watchErrors(): void {
  if (watching) return;
  watching = true;
  window.addEventListener("error", (e) => noteError("uncaught", e.message || String(e.error)));
  window.addEventListener("unhandledrejection", (e) => noteError("unhandled rejection", e.reason instanceof Error ? e.reason.message : String(e.reason)));
}
